/**
 * 文件说明:
 *
 * sub content
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo} from 'react'
import {Layout} from 'antd'

const SubContent = memo((props) => {
    const {SiderMenu, children} = props

    return (
        <Layout>
            {SiderMenu || null}
            {children}
        </Layout>
    )
})

export default SubContent
